export const addProduct = (cart, id, typeIndex, quantity)=> {

    const matchIndex = cart.findIndex(cartItem => {
        return cartItem.id === id && cartItem.typeIndex === typeIndex;
    })

    if (matchIndex === -1) {
        return [
            ...cart,
            {
                id,
                typeIndex,
                quantity
            }
        ]
    }
    else {
        return [
            ...cart.slice(0, matchIndex),
            { ...cart[matchIndex], quantity: cart[matchIndex].quantity + parseInt(quantity) },
            ...cart.slice(matchIndex + 1)
        ]
    }
} 

export const removeProduct = (cart, id, typeIndex) => {
    console.log(typeIndex);

    return cart.filter((item, i) => {
        return !(item.id === id && typeIndex === item.typeIndex);
    });
}

export const updateCartQuantity = (cart, index, quantity) => {
    let copy = [...cart];
    copy[index].quantity = quantity;
    return copy;
}


// WEBPACK FOOTER //
// ./src/pages/Store/Utils/CartUtils.js